<template>
  <div>
    <PatientCreation
      @save="save"
      @cancel="cancel"
    />
  </div>
</template>

<script setup lang="ts">
import { Patient } from "@/entities/patient";
import { computed, toRaw } from "vue";
import { useRouter } from "vue-router";
import PatientCreation from "@/components/patients/PatientCreation.vue";
import { usePhysiciansStore } from '@/stores/physicians';
import { usePatientsStore } from "@/stores/patients";

defineOptions({ name: "Patient" });

const physiciansStore = usePhysiciansStore();
const patientsStore = usePatientsStore();
const router = useRouter();

const getPhysician = computed(() => physiciansStore.getPhysician);
const getPhysicianId = computed(() => getPhysician.value?.userId || "");

function cancel() {
  patientsStore.resetPatient();
  router.push({ path: "/MyPatients" });
}

async function save(patient: Patient) {
  const physId = getPhysicianId.value || "";
  const plainPatient = toRaw(patient);
  if (patient.patientId > 0) {
    await patientsStore.putPatient(plainPatient, physId);
  } else {
    await patientsStore.postPatient(plainPatient, physId);
  }
  await router.push({path: "/MyPatients"});
  window.localStorage.setItem("refreshPatients", "");
}
</script>
